'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _media = require('lemon-db/dist/options/media.json');

var _media2 = _interopRequireDefault(_media);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var options = exports.options = {
  size: _media2['default'].size
};
var hexRegex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var Image = function (_React$Component) {
    _inherits(Image, _React$Component);

    function Image(props) {
      _classCallCheck(this, Image);

      var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

      _this.hdImage = _react2['default'].createRef();
      return _this;
    }

    _createClass(Image, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.preloadImage();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
          this.preloadImage();
        }
      }
    }, {
      key: 'preloadImage',
      value: function preloadImage() {
        var _this2 = this;

        var hdImageRef = this.hdImage.current;

        if (!hdImageRef || !this.props.src) {
          return;
        }

        this.props.theme.imageHdFadeIn.split(' ').forEach(function (className) {
          hdImageRef.classList.remove(className);
        });
        var newImage = document.createElement('img');
        newImage.src = this.props.src;

        newImage.onload = function () {
          return _this2.setImgSrc();
        };
      }
    }, {
      key: 'setImgSrc',
      value: function setImgSrc() {
        var hdImageRef = this.hdImage.current;

        if (!hdImageRef || !this.props.src) {
          return;
        }

        hdImageRef.setAttribute('style', 'background-image: url(\'' + this.props.src + '\')');
        this.props.theme.imageHdFadeIn.split(' ').forEach(function (className) {
          hdImageRef.classList.add(className);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            className = _props.className;
        return _react2['default'].createElement('div', {
          className: this.imageClasses
        }, _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])(theme.imageHd, className),
          ref: this.hdImage
        }), _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])(theme.imagePlaceholder, className),
          style: this.placeholderStyle
        }));
      }
    }, {
      key: 'placeholderStyle',
      get: function get() {
        var placeholder = this.props.placeholder;
        var isHex = hexRegex.test(placeholder);

        if (isHex) {
          return {
            backgroundColor: placeholder
          };
        }

        return {
          backgroundImage: 'url(\'' + placeholder + '\')'
        };
      }
    }, {
      key: 'imageClasses',
      get: function get() {
        var _props2 = this.props,
            theme = _props2.theme,
            preventDesktopBehaviour = _props2.preventDesktopBehaviour;
        return (0, _classnames2['default'])(theme.image, theme.imageContainer, _defineProperty({}, theme.preventDesktop, preventDesktopBehaviour));
      }
    }]);

    return Image;
  }(_react2['default'].Component);

  Image.displayName = identifier;
  Image.themeShape = {
    image: _propTypes2['default'].string.isRequired,
    small: _propTypes2['default'].string.isRequired,
    medium: _propTypes2['default'].string.isRequired,
    large: _propTypes2['default'].string.isRequired,
    imageContainer: _propTypes2['default'].string.isRequired,
    imagePlaceholder: _propTypes2['default'].string.isRequired,
    imageHd: _propTypes2['default'].string.isRequired,
    imageHdLoaded: _propTypes2['default'].string.isRequired,
    imageHdFadeIn: _propTypes2['default'].string.isRequired,
    preventDesktop: _propTypes2['default'].string.isRequired
  };
  Image.propTypes = {
    size: _propTypes2['default'].oneOf(Object.values(options.size)),
    src: _propTypes2['default'].string.isRequired,
    placeholder: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    alwaysFetch: _propTypes2['default'].bool,
    theme: _propTypes2['default'].shape(Image.themeShape).isRequired,
    preventDesktopBehaviour: _propTypes2['default'].bool
  };
  Image.defaultProps = {
    size: 'medium',
    placeholder: '',
    preventDesktopBehaviour: false
  };
  return Image;
};

exports['default'] = factory;